import { Heart, Sparkles, PenTool } from "lucide-react";
import { Reveal, SectionTag, BigHead } from "./Reveal";
import { CircleCluster } from "./Circles";

export const About = ({ ch = "01" }) => (
  <section id="about" data-testid="about-section" className="relative overflow-hidden bg-white py-24 sm:py-32">
    <CircleCluster className="absolute -left-24 -bottom-16 opacity-90 scale-75 hidden md:block" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5 relative">
          <Reveal>
            <div className="relative">
              <div className="ink-dot absolute -left-8 -top-8 h-28 w-28 bg-staxyellow" />
              <div className="ink-dot absolute -right-6 -bottom-6 h-24 w-24 bg-staxcyan" />
              <div className="relative border-4 border-ink bg-gradient-to-br from-staxyellow via-white to-staxcyan aspect-[4/5] shadow-hard overflow-hidden">
                <div className="absolute inset-0 halftone opacity-10" />
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-8 text-center">
                  <div className="flex -space-x-4">
                    <span className="ink-dot h-20 w-20 bg-staxyellow border-2 border-ink" />
                    <span className="ink-dot h-20 w-20 bg-staxcyan border-2 border-ink" />
                    <span className="ink-dot h-20 w-20 bg-staxmagenta border-2 border-ink" />
                  </div>
                  <p className="font-display uppercase text-3xl text-ink leading-tight">
                    The Designer<br />Behind STAX
                  </p>
                  <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-ink/60">Portrait coming soon</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <SectionTag color="bg-staxcyan text-ink" ch={ch}>About the Designer</SectionTag>
          </Reveal>
          <Reveal delay={0.08}>
            <BigHead className="mt-6">
              Good design should<br />
              <span className="text-staxmagenta">do more</span> than<br />
              look good.
            </BigHead>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-7 max-w-xl text-base sm:text-lg text-ink/70 font-medium leading-relaxed">
              I'm a designer, strategist, and creative problem solver who believes good design
              should make people feel something, remember something, and ultimately take action.
              Every project gets strategy first, pixels second — and color always.
            </p>
          </Reveal>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
            <Reveal delay={0.2}>
              <div className="border-4 border-ink bg-staxyellow p-6 shadow-hard-sm h-full">
                <div className="flex items-center gap-2 font-display uppercase text-xl text-ink">
                  <Heart size={20} fill="#0A0A0A" /> I Love
                </div>
                <ul className="mt-4 space-y-2 font-mono2 text-sm font-bold uppercase tracking-wide text-ink">
                  <li>→ God</li>
                  <li>→ Beyonce / Kendrick Lamar / Chance The Rapper</li>
                  <li>→ Sims</li>
                  <li>→ Abbott Elementary / The Office</li>
                </ul>
              </div>
            </Reveal>
            <Reveal delay={0.28}>
              <div className="border-4 border-ink bg-ink p-6 shadow-hard-sm h-full">
                <div className="flex items-center gap-2 font-display uppercase text-xl text-white">
                  <Sparkles size={20} className="text-staxyellow" /> I Believe
                </div>
                <p className="mt-4 font-display uppercase text-2xl leading-snug text-white">
                  Good design should have a <span className="text-staxcyan">point of view.</span>
                </p>
                <p className="mt-4 font-mono2 text-xs uppercase tracking-[0.25em] text-white/60 flex items-center gap-2">
                  <PenTool size={14} /> Design that sticks
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);
